import React from 'react';
import './../Style/NEETEligibilityCriteria2027.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const NEETEligibilityCriteria2027 = () => {
  // Key Highlights Data Table
  const highlightsData = [
    {
      criteria: 'Educational Qualification',
      details: (
        <span>
          10+2 or equivalent exam with Physics, Chemistry, Biology/Biotechnology, and English
        </span>
      ),
    },
    {
      criteria: 'Required Marks',
      details: (
        <div className="neeteligibility-sublist">
          <div>General – 50%</div>
          <div>OBC/SC/ST – 40%</div>
          <div>PwD – 45%</div>
        </div>
      ),
    },
    {
      criteria: 'Minimum Age',
      details: '17 years (Born on or before December 31, 2009)',
    },
    {
      criteria: 'Maximum Age',
      details: 'No upper age limit',
    },
    {
      criteria: 'Nationality',
      details: 'Indian Citizens, NRI, OCI, PIO, and Foreign Nationals',
    },
    {
      criteria: 'Number of Attempts',
      details: 'No limit on the number of attempts',
    },
    {
      criteria: 'Score Validity',
      details: 'Valid for only one academic session (2027–27)',
    },
  ];

  // Criteria by Category Data Table
  const categoryData = [
    { category: 'Unreserved', marks: '50%' },
    { category: 'SC/ST/OBC/Reserved-PH', marks: '40%' },
    { category: 'Unreserved-PH', marks: '45%' },
  ];

  // Age Limit Data Table
  const ageData = [
    {
      category: 'Unreserved Category (UR)',
      minAge: 'Born on or before December 31, 2009',
      maxAge: 'No upper limit',
    },
    {
      category: 'SC/ST/OBC',
      minAge: '-',
      maxAge: '-',
    },
  ];

  // Qualifying Codes Data Table
  const qualifyingCodesData = [
    {
      code: '01',
      description:
        'For candidates awaiting Class 12 results. They must meet Class 12 criteria by admission time.',
    },
    {
      code: '02',
      description:
        'For those preparing for higher secondary exams or equivalent. This applies to "droppers."',
    },
    {
      code: '03',
      description:
        'For candidates who completed their Intermediate/Pre-degree in Science from recognized boards.',
    },
    {
      code: '04',
      description:
        'For those who passed Pre-professional/Pre-medical exams with compulsory subjects.',
    },
    {
      code: '05',
      description:
        'For candidates pursuing a three-year degree with Physics, Chemistry, and Biology as subjects.',
    },
    {
      code: '06',
      description:
        'For those who passed BSc with at least two subjects among Physics, Chemistry, Biology/Biotechnology, and English.',
    },
    {
      code: '07',
      description:
        'For those who cleared an equivalent exam in India or abroad for the last two years of 10+2 study.',
    },
  ];

  return (
    <div className="neeteligibility-container">

        <TopNavbar name="NEET Eligibility Criteria" ></TopNavbar>
        <TopHeader name="NEET Eligibility Criteria" ></TopHeader>
     

      {/* Main Content Area */}
      <main className="neeteligibility-content">
        <h2 className="neeteligibility-main-title">
          NEET 2027 : Eligibility Criteria
        </h2>

        <p className="neeteligibility-paragraph">
          If you are dreaming of becoming a doctor, the first step is to
          understand the eligibility conditions of NEET 2027. Conducted by the
          National Testing Agency (NTA), this exam is mandatory for admission to
          MBBS, BDS, BAMS, BHMS, BUMS, BSMS and other medical courses in India.
        </p>

        <p className="neeteligibility-paragraph">
          In this article, we will give detailed information on NEET 2027
          educational qualification, age limit, number of attempts, nationality,
          and all other important eligibility criteria.
        </p>

        {/* Section 1: Key Highlights */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            NEET UG Eligibility Criteria 2027 - Key Highlights
          </h3>
          <div className="neeteligibility-table-container">
            <table className="neeteligibility-table">
              <thead>
                <tr>
                  <th>Criteria</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {highlightsData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="neeteligibility-col-highlight">
                      {row.criteria}
                    </td>
                    <td>{row.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Section 2: Educational Qualification */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            Detailed Information about Educational Qualification
          </h3>
          <p className="neeteligibility-paragraph">
            To appear in NEET 2027, candidates must have passed 12th with Physics,
            Chemistry, Biology/Biotechnology and English subjects. It is necessary
            to pass all the subjects separately.
          </p>
        </section>

        {/* Section 3: Eligibility by Category */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            NEET Eligibility Criteria by Category
          </h3>
          <p className="neeteligibility-paragraph">
            Here's a breakdown of the eligibility requirements by category:
          </p>
          <div className="neeteligibility-table-container">
            <table className="neeteligibility-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Marks Required for NEET 2027</th>
                </tr>
              </thead>
              <tbody>
                {categoryData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="neeteligibility-col-highlight">
                      {row.category}
                    </td>
                    <td className="neeteligibility-col-value">{row.marks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Section 4: Eligibility Age */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            NEET Eligibility Age
          </h3>
          <p className="neeteligibility-paragraph">
            In 2027, there are key changes to the NEET age criteria. Here are the
            details:
          </p>
          <div className="neeteligibility-table-container">
            <table className="neeteligibility-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Minimum Age Requirement</th>
                  <th>Maximum Age Requirement</th>
                </tr>
              </thead>
              <tbody>
                {ageData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="neeteligibility-col-highlight">
                      {row.category}
                    </td>
                    <td>{row.minAge}</td>
                    <td>{row.maxAge}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Section 5: Limit of Attempts */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">Limit of Attempts</h3>
          <p className="neeteligibility-paragraph">
            There is no limit on the number of times you can appear for NEET
            2027. As long as you meet the eligibility criteria, you can take the
            exam as many times as you want.
          </p>
        </section>

        {/* Section 6: NRI/Foreign Students */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            Eligibility for NRI/Foreign Students
          </h3>
          <p className="neeteligibility-paragraph">
            Foreign students need to meet specific requirements for NEET:
          </p>
          <ul className="neeteligibility-list">
            <li>
              They must complete an exam equivalent to Class 12 in their home
              country.
            </li>
            <li>
              They need to study Physics, Chemistry, and Biology, passing both
              theoretical and practical exams, along with an English exam.
            </li>
          </ul>

          <h4 className="neeteligibility-sub-title">Important Notes:</h4>
          <ul className="neeteligibility-list">
            <li>
              NRIs and OCI applicants must submit a certificate from the Indian
              Diplomatic Mission to confirm their status when applying online.
            </li>
            <li>
              Foreign applicants should provide proof of citizenship, like
              valid passport pages or a certificate from their home country.
            </li>
          </ul>
        </section>

        {/* Section 7: Validity of NEET UG Scores */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            Validity of NEET UG Scores
          </h3>
          <p className="neeteligibility-paragraph">
            The NEET score you get in 2027 is valid for one academic year. If
            you pass, you can apply for admission to medical and dental programs
            for the academic year 2027–2027. However, passing the exam does not
            guarantee admission. You must also participate in the NEET 2027
            counseling process and meet the individual college requirements.
          </p>
        </section>

        {/* Section 8: Qualifying Codes */}
        <section className="neeteligibility-section">
          <h3 className="neeteligibility-section-title">
            NEET (UG) 2027 Qualifying Codes
          </h3>
          <p className="neeteligibility-paragraph">
            Here are the qualifying codes for NEET UG 2027:
          </p>
          <div className="neeteligibility-table-container">
            <table className="neeteligibility-table">
              <thead>
                <tr>
                  <th style={{ width: '80px' }}>Code</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {qualifyingCodesData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="neeteligibility-code-cell">{row.code}</td>
                    <td>{row.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Closing Paragraph */}
        <p className="neeteligibility-paragraph neeteligibility-footer-note">
          Stay updated with all the information you need about NEET 2027. Make
          sure you’re prepared with the right study materials and support. If
          you have questions or need more information feel free to reach out!
        </p>
      </main>

   
    </div>
  );
};

export default NEETEligibilityCriteria2027;